import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, ChangeDetectorRef ,ElementRef} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { environment } from 'src/environments/environment';
import { FileService } from 'src/app/shared/services/file.service';
import { Common } from 'src/app/common';
import { HttpErrorResponse } from '@angular/common/http';
import { log } from 'console';
import { FormGroup ,FormBuilder ,Validators} from '@angular/forms';
declare var $:any



@Component({
  selector: 'app-holiday-calendar',
  templateUrl: './holiday-calendar.component.html',
  styleUrls: ['./holiday-calendar.component.css']
})
export class HolidayCalendarComponent implements OnInit {
  hldyLst: any = []; dtReneder: boolean = false; dtOptions = {};
  selectedFile: string | Blob;
  successList: any[] = [];
  FailureList: any[] = [];
  successCount: any;
  FailureCount: any;
  uploaded: boolean = false;
  screennames: any;
  newDate: any;
  isTemplateEnable: boolean = false;
  modalTitle:any;
  holidayForm :FormGroup;
  submitted:boolean = false;
  eid:any;
  currentYear = new Date().getFullYear();
  minDate = new Date(this.currentYear, 0, 1);   // Jan 1 of current year
  maxDate = new Date(this.currentYear, 11, 31); // Dec 31 of current year

   get fc() {
    return this.holidayForm.controls;
  }

  constructor(
    private registrationService: RegistrationService,
    private toaster: ToastrService,
    private datepipe: DatePipe,
    private fileService: FileService,
    public el: ElementRef,
    private cd : ChangeDetectorRef,
    private formBuilder: FormBuilder


  ) { }
  @HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  const target = event.target as HTMLElement;

  // Check if click is inside an editable control or edit/save icon
  if (
    target.closest('input') || 
    target.closest('.fa-edit') || 
    target.closest('.fa-check')
  ) {
    return; // don't reset if clicked inside edit UI
  }

  // Otherwise, reset all edit modes
  this.hldyLst.forEach((el: any) => (el.onEdit = false));
}

  ngOnInit(): void {
    this.loadData();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      dom: 'Bfrtip',
      processing: true,
      buttons: [
        {
          extend: 'excelHtml5',
          title: 'Holiday list',
          exportOptions: { columns: ':visible:not(:first-child)' }
        },
      ]
    };
    this.sideMenupermission();
    this.getFeaturePermission();
    this.formInIt();
 
  }

   sideMenupermission() {
    this.screennames = JSON.parse(sessionStorage.getItem('menu'));

  }

  formInIt(){
    this.holidayForm = this.formBuilder.group({
      holiday_name :['',Validators.required],
      holiday_date :[new Date(),Validators.required],
      account_activated :[true],

    })
  }

  yearWiseCalender(){
    // this.currentYear = new Date().getFullYear();
    // this.minDate = new Date(this.currentYear - 1, 0, 1);  // Jan 1 of previous year
    // this.maxDate = new Date(this.currentYear, 11, 31);    // Dec 31 of current year

    this.currentYear = new Date().getFullYear();
    this.minDate = new Date(this.currentYear, 0, 1);   // Jan 1 of current year
    this.maxDate = new Date(this.currentYear, 11, 31); // Dec 31 of current year
  }


   getFeaturePermission() {
    var featureList: any = JSON.parse(localStorage.getItem('featuresList'));
    for (let i = 0; i < featureList.length; i++) {
      if (featureList[i].feature_id.feature_name == "EnableTemplateForBulkUpload") {
        this.isTemplateEnable  = featureList[i].patient;
      }
     
    }
  }
  loadData() {
    this.dtReneder = false;
    this.registrationService.get(`masters/getallmasterleaves`).subscribe(
      (res) => {
        if (res.status == 'OK') {
          if (res.data == '' || res.data == null || res.data == undefined) {
            this.toaster.info(res.message)
          }
          else {
            this.hldyLst = res.data;
            this.hldyLst.forEach((el:any) => { el.onEdit=false});
            this.dtReneder = true;
            this.toaster.success(res.message)
          }
        }
        else {
          this.toaster.error(res.message)
        }
      }
    )
  }
  templateDownload() {
    let hostUrl = location.origin.includes('localhost') ? environment.applicationURL : location.origin;

    Common.showlabpharmaPDF_File(`${hostUrl}/masters/gettemplateformasterholiday?TENANT_ID=${sessionStorage.TENANT_ID}`)
    // this.regService.get(`registration/camp/getTemplateForCampRegistrations`).subscribe({
    //   next: res => {
    //     if (res.status == 'OK') {
    //       this.toastr.success(res.message)

    //     } else {
    //       let errMsg: string = res.message;
    //       this.toastr.error(errMsg);
    //       this.dtRender = true
    //     }
    //   },
    //   error: (err: HttpErrorResponse) => {
    //     this.toastr.error(err.message);
    //     this.dtRender = true

    //   },
    //   complete: () => {
    //     // Any additional logic after patching values
    //   },
    // });
  }
  onFileSelected(event: any): void {
    const file = event.target.files[0];
    this.selectedFile = event.target.files[0];

    // Validate file type
    const validFileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (file && validFileTypes.includes(file.type)) {
      const formData = new FormData();
      formData.append("file", this.selectedFile);

      //   this.fileService.fileuploadExcel(`vidmed-login/registration/camp/saveCampRegistrationFromExcel`,formData).subscribe(
      //     (response:any) => 
      //       this.toastr.success('File uploaded successfully!', 'Camp Creation'),
      //     error => this.toastr.error('Error uploading file', 'Camp Creation')

      //   );
      // } 
      this.fileService.fileuploadExcel(`vidmed-login/masters/saveexcelmasterholidaylist`, formData).subscribe(
        (response: any) => {
          this.toaster.success('File uploaded successfully!', 'Holiday List');

          // Handle response here
          if (response.status == 'OK') {

            console.log('Success:', response.data);
            // this.successList = response.data.SuccessList || []
            // this.FailureList = response.data.failList || []
            // this.successCount = response.data.SuccessCount || 0
            // this.FailureCount = response.data.FailCount || 0
          }
          if (this.successList.length > 0 || this.FailureList.length > 0) {
            this.uploaded = true
          } else {
            this.uploaded = false
          }
          this.loadData();
        },
        (error) => {
          console.error('API Error:', error);
          this.toaster.error('Error uploading file', 'Holiday List');
        }
      );

    } else {
      this.toaster.error('Invalid file type. Please upload an Excel file (.xls or .xlsx).');
    }
    event.target.files = []
  }


  onEdit(item){
    this.hldyLst.forEach((el:any) => { el.onEdit=false});
    item.onEdit = true
  }
 onDateChange(item: any, value: any) {
  this.newDate = null;
  this.cd.detectChanges();

  // 🧠 Manually parse dd-MM-yyyy format
  const parts = value.split('-'); // ["01","12","2025"]
  if (parts.length === 3) {
    // Convert to yyyy-MM-dd so DatePipe reads it correctly
    this.newDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  this.cd.detectChanges();
}


  onUpdate(item:any){
    this.cd.detectChanges()
    let payload = {
      date:this.newDate,
      id:item.id,
      is_active:true,
      name:item.name
    }
    console.log('payload',payload);
        this.registrationService.post(`masters/holidaylist-save`,payload).subscribe({
          next: res => {
            if (res.status == 'OK') {
             this.toaster.success("Record Updated Successfully")
             this.newDate=null
             this.loadData();
    
            } else {
              let errMsg: string = res.message;
              this.toaster.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toaster.error(err.message);
    
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });

  }

  onDelete(item) {
    if (confirm(`Are you sure you want delete record?`)) {
      this.registrationService.delete(`masters/deletebyid/${item.id}`).subscribe(res => {
        if (res.status == "OK")
          this.toaster.success('Record Deleted Successfully'), this.loadData();
        else
          this.toaster.error(res.message);
      }, error => { this.toaster.error('An Error Occured'); });
    }
  }

  openModal(isEdit:boolean=false ,item:any){
    this.formInIt();
  $('#addHoliday').modal('show')
  if(isEdit){
  this.holidayForm.patchValue({
    holiday_name :item?.name,
      holiday_date : new Date(item?.date),
      account_activated : item?.is_active,
  })
  }
  this.eid = item?.id || 0
  
  }

  onSubmit(){
     this.submitted = true;
    if (this.holidayForm.invalid) {
      this.toaster.info('Please Enter All Mandatory Fields');
      for (const key of Object.keys(this.holidayForm.controls)) {
        if (this.holidayForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector(
            '[formcontrolname="' + key + '"]'
          );
          invalidControl.focus();
          return;
        }
      }
      return false;
    }

 this.cd.detectChanges()
    let payload = {
      date : this.datepipe.transform(this.holidayForm.value.holiday_date,'yyyy-MM-dd'),
      id : this.eid,
      is_active : this.holidayForm.value.account_activated,
      name : this.holidayForm.value.holiday_name
    }
    console.log('payload',payload);
        this.registrationService.post(`masters/holidaylist-save`,payload).subscribe({
          next: res => {
            if (res.status == 'OK') {
             this.toaster.success(res.message)
              $('#addHoliday').modal('hide')
             this.loadData();
    
            } else {
              let errMsg: string = res.message;
              this.toaster.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toaster.error(err.message);
    
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });

  }


}
